const baseURL = 'https://onlyforgirls.com.mx/';

export default baseURL;
